<div class="edit-posting-btn-content">
  <div class="edit-posting-note">
    <div>{{editPostingButtonsTranslations.textOnlySelect}} {{editPostingButtonsTranslations.saveFormButtonLabel}} {{editPostingButtonsTranslations.textSelectAllChange}}</div>
    @if (showCancelOffers()) {
      <div >
        <strong [innerHTML]="editPostingButtonsTranslations.textCancelOfferAutobids"></strong>
      </div>
    }
  </div>
  <div class="edit-posting-btns">
    <button
      class="btn btn-primary save-posting-btn"
      [attr.data-track-name]="analyticsSaveFormButtonLabel"
      [attr.aria-label]="editPostingButtonsTranslations.saveFormButtonLabel"
      (click)="handleSubmitPosting()"
      >
      {{editPostingButtonsTranslations.saveFormButtonLabel}}
    </button>
    <button
      class="btn cancel btn-link outline-focus"
      [attr.data-track-name]="'Cancel'"
      [attr.aria-label]="editPostingButtonsTranslations.cancel"
      (click)="onCancel()"
      >
      {{editPostingButtonsTranslations.cancel}}
    </button>
  </div>
</div>

<app-multi-error-modal
  [errorList]="postingErrorList"
  [modalHeaderText]="multiErrorHeaderTranslationKey"
  (multiErrorModalBtnSuccessAction)="continuePostingVehicle($event)">
</app-multi-error-modal>

<app-auction-lane-selection-modal
  (closeSelectionModal)="submitPosting()">
</app-auction-lane-selection-modal>

<app-form-tracking-modal
  (continueSubmission)="getAvailableAuctionLaneSelections()">
</app-form-tracking-modal>

<app-error-modal>
</app-error-modal>

<provincial-restriction-error-modal>
</provincial-restriction-error-modal>
